export default class Peace{
    constructor(cells){
        this.cells = cells;

        this.dimension = this.cells.length;
        this.row = 0;
        this.column = 0;
        this.fliprow = 3;//X軸で反転しても意味のないもの
    }
    static fromIndex(index) {// 静的メソッドの定義
        var piece;
        switch (index){
            case 0:// 2
                piece = new this([
                    [0x00001, 0x00001],
                    [0x00000, 0x00000]
                ]);
                break;
            case 1: // 3
                    piece = new this([
                        [0x000004, 0x00004, 0x000004],
                        [0x000000, 0x00000, 0x000000],
                        [0x000000, 0x000000, 0x000000]
                    ]);
                    break;
            case 2: // 4
                    piece = new this([
                        [0x000000, 0x00000, 0x000000,0x00000],
                        [0x00000D, 0x0000D, 0x00000D,0x0000D],
                        [0x000000, 0x00000, 0x000000,0x00000],
                        [0x000000, 0x00000, 0x000000,0x00000]
                    ]);
                    break;
         
            case 3: // 
            case 4:
                piece = new this([
                    [0x00002, 0x00002],
                    [0x00000, 0x00002]
                ]);
                break;

           
            case 5: // I
            case 6: // I
                piece = new this([
                    [0x000007, 0x00007, 0x000000],
                    [0x000000, 0x00007, 0x000000],
                    [0x000000, 0x00007, 0x000000]
                ]);
                break;
          
            case 7: // I
            case 8: // I
                    piece = new this([
                        [0x00000b, 0x0000b, 0x000000],
                        [0x000000, 0x0000b, 0x00000b],
                        [0x000000, 0x00000, 0x000000]
                    ]);
                    break;
            //5peace
            case 9: // 5
            case 10:
            piece = new this([
                [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                [0x00000D, 0x0000D, 0x00000D,0x0000D,0x0000D],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000]
            ]);
            break;
    
            case 11: //
            case 12: 
                    piece = new this([
                        [0x000000, 0x00000, 0x000000,0x00000],
                        [0x00000D, 0x0000D, 0x00000D,0x0000D],
                        [0x000000, 0x00000, 0x000000,0x0000D],
                        [0x000000, 0x00000, 0x000000,0x00000]
                    ]);
                    break; 
            case 13: //
            case 14: 
                    piece = new this([
                        [0x00000D, 0x0000D, 0x00000D],
                        [0x000000, 0x00000, 0x00000D],
                        [0x000000, 0x00000, 0x00000D]
                    ]);
                    break;
            case 15: //
            case 16: 
                    piece = new this([
                        [0x00000D, 0x00000D ,0x00000,0x0000],
                        [0x000000, 0x00000D, 0x0000D,0x000D],
                        [0x000000, 0x000000, 0x00000,0x00000],
                        [0x000000, 0x000000, 0x00000,0x00000]
                        
                    ]);
                    break; 
          //6peace
          case 17: // 6
          case 18:
            piece = new this([
                [0x000000, 0x00000, 0x000000,0x00000,0x00000,0x00000],
                [0x00000D, 0x0000D, 0x00000D,0x0000D,0x0000D,0x0000D],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000,0x00000],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000,0x00000],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000,0x00000],
                [0x000000, 0x00000, 0x000000,0x00000,0x00000,0x00000]
            ]);
            break;    
            case 19:
            case 20:
                piece = new this([
                    [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                    [0x00000D, 0x0000D, 0x00000D,0x0000D,0x0000D],
                    [0x000000, 0x00000, 0x000000,0x00000,0x0000D],
                    [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                    [0x000000, 0x00000, 0x000000,0x00000,0x00000]
                ]);
                break;     
            case 21:
            case 22:
                    piece = new this([
                        [0x000000, 0x00000, 0x000000,0x00000],
                        [0x00000D, 0x0000D, 0x00000D,0x0000D],
                        [0x000000, 0x00000, 0x000000,0x0000D],
                        [0x000000, 0x00000, 0x000000,0x00000]
                    ]);
                    break;    
            case 23:
            case 24:
                    piece = new this([
                            [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                            [0x00000D, 0x0000D, 0x00000D,0x00000,0x00000],
                            [0x000000, 0x00000, 0x00000D,0x0000D,0x0000D],
                            [0x000000, 0x00000, 0x000000,0x00000,0x00000],
                            [0x000000, 0x00000, 0x000000,0x00000,0x00000]
                    ]);
                    break; 
            case 25:
            case 26:
                    piece = new this([
                                [0x00000D, 0x0000D, 0x000000,0x00000],
                                [0x000000, 0x0000D, 0x00000D,0x00000],
                                [0x000000, 0x00000, 0x00000D,0x0000D],
                                [0x000000, 0x00000, 0x000000,0x00000]
                    ]);
                    break;    
        }
        if(index > piece.fliprow && (index-piece.fliprow)%2 == 0){
            piece.xflip();
        }
        piece.fill(index+1)
        piece.id = index;
        piece.row = 0;
        piece.column = Math.floor((10 - piece.dimension) / 2); // Centralize
        return piece;
    }
    clone(){
        var _cells = new Array(this.dimension);
        for (var r = 0; r < this.dimension; r++) {
            _cells[r] = new Array(this.dimension);
            for(var c = 0; c < this.dimension; c++){
                _cells[r][c] = this.cells[r][c];
            }
        }
    
        var piece = new this.constructor(_cells);
        piece.row = this.row;
        piece.column = this.column;
        return piece;
    }
    canMoveLeft(grid){
        for(var r = 0; r < this.cells.length; r++){
            for(var c = 0; c < this.cells[r].length; c++){
                var _r = this.row + r;
                var _c = this.column + c - 1;
                if (this.cells[r][c] != 0){
                    if (!(_c >= 0 && grid.cells[_r][_c] == 0)){
                        return false;
                    }
                }
            }
        }
        return true;
    }
    
    canMoveRight(grid){
        for(var r = 0; r < this.cells.length; r++){
            for(var c = 0; c < this.cells[r].length; c++){
                var _r = this.row + r;
                var _c = this.column + c + 1;
                if (this.cells[r][c] != 0){
                    if (!(_c >= 0 && grid.cells[_r][_c] == 0)){
                        return false;
                    }
                }
            }
        }
        return true;
    }
    
    
    canMoveDown(grid){
        for(var r = 0; r < this.cells.length; r++){
            for(var c = 0; c < this.cells[r].length; c++){
                var _r = this.row + r + 1;
                var _c = this.column + c;
                if (this.cells[r][c] != 0 && _r >= 0){
                    if (!(_r < grid.rows && grid.cells[_r][_c] == 0)){
                        return false;
                    }
                }
            }
        }
        return true;
    }
    
    moveLeft(grid){
        if(!this.canMoveLeft(grid)){
            return false;
        }
        this.column--;
        return true;
    }
    
    moveRight(grid){
        if(!this.canMoveRight(grid)){
            return false;
        }
        this.column++;
        return true;
    };
    
    moveDown(grid){
        if(!this.canMoveDown(grid)){
            return false;
        }
        this.row++;
        return true;
    }
    
    rotateCells(){
          var _cells = new Array(this.dimension);
          for (var r = 0; r < this.dimension; r++) {
              _cells[r] = new Array(this.dimension);
          }
    /*
          switch (this.dimension) { // Assumed square matrix
              case 2:
                  _cells[0][0] = this.cells[1][0];
                  _cells[0][1] = this.cells[0][0];
                  _cells[1][0] = this.cells[1][1];
                  _cells[1][1] = this.cells[0][1];
                  break;
              case 3:
                  _cells[0][0] = this.cells[2][0];
                  _cells[0][1] = this.cells[1][0];
                  _cells[0][2] = this.cells[0][0];
                  _cells[1][0] = this.cells[2][1];
                  _cells[1][1] = this.cells[1][1];
                  _cells[1][2] = this.cells[0][1];
                  _cells[2][0] = this.cells[2][2];
                  _cells[2][1] = this.cells[1][2];
                  _cells[2][2] = this.cells[0][2];
                  break;
              case 4:
                  _cells[0][0] = this.cells[3][0];
                  _cells[0][1] = this.cells[2][0];
                  _cells[0][2] = this.cells[1][0];
                  _cells[0][3] = this.cells[0][0];
                  _cells[1][3] = this.cells[0][1];
                  _cells[2][3] = this.cells[0][2];
                  _cells[3][3] = this.cells[0][3];
                  _cells[3][2] = this.cells[1][3];
                  _cells[3][1] = this.cells[2][3];
                  _cells[3][0] = this.cells[3][3];
                  _cells[2][0] = this.cells[3][2];
                  _cells[1][0] = this.cells[3][1];
    
                  _cells[1][1] = this.cells[2][1];
                  _cells[1][2] = this.cells[1][1];
                  _cells[2][2] = this.cells[1][2];
                  _cells[2][1] = this.cells[2][2];
                  break;
                  default:
                      //任意行列の９０度回転
               
                      var w = this.dimension,
                      h = this.dimension;
               
                  for(var i = 0; i < h; i++) {
                      //var y = i * w;
                      for(var j = 0; j < w; j++) {
                         
                          _cells[j][i] = this.cells[i][j];
                         
                          
                      }
                  }
                  
          }
    */
   var w = this.dimension,
   h = this.dimension;

for(var i = 0; i < h; i++) {
   //var y = i * w;
   for(var j = 0; j < w; j++) {
      
       _cells[j][i] = this.cells[i][j];
      
       
   }
}
          this.cells = _cells;
    }
 
    
    computeRotateOffset(grid){
        var _piece = this.clone();
        _piece.rotateCells();
        if (grid.valid(_piece)) {
            return { rowOffset: _piece.row - this.row, columnOffset: _piece.column - this.column };
        }
    
        // Kicking
        var initialRow = _piece.row;
        var initialCol = _piece.column;
    
        for (var i = 0; i < _piece.dimension - 1; i++) {
            _piece.column = initialCol + i;
            if (grid.valid(_piece)) {
                return { rowOffset: _piece.row - this.row, columnOffset: _piece.column - this.column };
            }
    
            for (var j = 0; j < _piece.dimension - 1; j++) {
                _piece.row = initialRow - j;
                if (grid.valid(_piece)) {
                    return { rowOffset: _piece.row - this.row, columnOffset: _piece.column - this.column };
                }
            }
            _piece.row = initialRow;
        }
        _piece.column = initialCol;
    
        for (var i = 0; i < _piece.dimension - 1; i++) {
            _piece.column = initialCol - i;
            if (grid.valid(_piece)) {
                return { rowOffset: _piece.row - this.row, columnOffset: _piece.column - this.column };
            }
    
            for (var j = 0; j < _piece.dimension - 1; j++) {
                _piece.row = initialRow - j;
                if (grid.valid(_piece)) {
                    return { rowOffset: _piece.row - this.row, columnOffset: _piece.column - this.column };
                }
            }
            _piece.row = initialRow;
        }
        _piece.column = initialCol;
    
        return null;
    }
    
    rotate(grid,noOfst){
        if(noOfst){
            var offset ={rowOffset:0,columnOffset:0}
        }else{
            var offset = this.computeRotateOffset(grid);
        }
        if (offset != null){
            this.rotateCells();
            this.row += offset.rowOffset;
            this.column += offset.columnOffset;
        }
    }
    fill(no){
        var l = this.dimension
        for(var x =0;x<l;x++){
            for(var y =0;y<l;y++){
                if(this.cells[x][y]>0){
                    this.cells[x][y] = no
                }
            }
        }
    }
    xflip(){
       // var _cells = new Array(this.dimension);
       // for (var r = 0; r < this.dimension; r++) {
       //     _cells[r] = new Array(this.dimension);
       // }
       var l = this.dimension
       var cl = Math.floor(l/2)
       for(var x =0;x<cl;x++){
           for(var y =0;y<l;y++){
            var _c = this.cells[x][y]
            this.cells[x][y] = this.cells[l - x -1][y]
            this.cells[l - x -1][y] = _c
           }
       }
    }
    
}